<template>
  <div :class="$style.content">
    <ContactForm />
    <TextBlock :content="content.text" :title="content.title" />
    <ul>
      <li data-anim="stagger" v-for="item in content.list" :key="item" v-html="item"></li>
    </ul>
  </div>
</template>

<script>
import ContactForm from "@/components/ContactForm";
import TextBlock from "@/components/TextBlock";

export default {
  props: ['content'],
  components: {
    ContactForm,
    TextBlock
  }
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";

.content {
  @include grid-size();
  padding: 0 $big-margin-mobile $big-margin-mobile $big-margin-mobile;

  @include mq(sm) {
    padding: 0 $big-margin 200px $big-margin;
  }

  li {
    margin-top: 6px;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/JobList.vue